import { render, staticRenderFns } from "./sidemenuitem.vue?vue&type=template&id=23134143&"
import script from "./sidemenuitem.vue?vue&type=script&lang=js&"
export * from "./sidemenuitem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports